﻿import axios from 'axios';
axios.defaults.baseURL = '/api-frontend/';

import ServerError from '@/utils/server-error';

export async function get(url, params) {
    try {
        let query = params ? { params } : null;

        return (await axios.get(url, query)).data;
    }
    catch (error) {
        throw new ServerError(error);
    }
}

export async function post(url, data, config) {
    try {
        return (await axios.post(url, data, config)).data;
    }
    catch (error) {
        throw new ServerError(error);
    }
}

export async function put(url, data) {
    try {
        return (await axios.put(url, data)).data;
    }
    catch (error) {
        throw new ServerError(error);
    }
}

export async function del(url) {
    try {
        return (await axios.delete(url)).data;
    }
    catch (error) {
        throw new ServerError(error);
    }
}